<div class="portal-row">
    <div class="portal-items-container">
        @for (agendaPortalLink of portalAgendaContainer.agendas; track agendaPortalLink) {
            <crczp-portal-agenda-link
                [portalAgendaLink]="agendaPortalLink"
                [elevation]="elevation"
                (navigate)="navigate($event)"
                (elevate)="elevate($event)"/>
        }
    </div>
    <div class="portal-description-container">
        <h2>{{ portalAgendaContainer.label }}</h2>
        @for (agenda of portalAgendaContainer.agendas; track agenda) {
            <crczp-portal-agenda-description
                [label]="agenda.label"
                [description]="agenda.description"
                [elevation]="elevation"
                (elevate)="elevate($event)"/>
        }
    </div>
</div>
